import { atom } from 'recoil';

export enum RoutesStates {
  HOME = 'HOME',
  DOCS = 'DOCS',
  PRICING = 'PRICING',
  COMPANY = 'COMPANY',
  CONTACT = 'CONTACT',
  LOGIN = 'login',
  SIGNUP = 'signup',
  PROFILE = 'PROFILE',
  DOWNLOAD = 'DOWNLOAD',
  UNKNOWN = 'UNKNOWN',
  CANDLESTICK = 'CANDLESTICK',
  CANDLESTICK_CHART = 'CANDLESTICK_CHART',
}

export const RoutesStatesAtom = atom<RoutesStates>({
  key: 'RoutesStates',
  default: RoutesStates.HOME,
});